
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/set-14/tables/loot-orbs",
      function () {
        return require("private-next-pages/info/set-14/tables/loot-orbs.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/set-14/tables/loot-orbs"])
      });
    }
  